/**
 * Orientation 2026 Section
 * - Moves the reviews section into the page flow.
 * - Handles banner carousel and kit modal interactions.
 */
(function () {
  var REVIEWS_SLOT_SELECTOR = '[data-orientation-2026-reviews-slot]';
  var REVIEWS_MARKER_SELECTOR = '.orientation-2026-image-with-reviews';
  var REVIEWS_SECTION_ID_FRAGMENT = 'image_with_reviews_orientation_2026';
  var CATEGORY_LINK_SELECTOR = '[data-orientation-2026-category-link]';
  var ANCHOR_LINK_SELECTOR = '[data-orientation-2026-anchor-link]';
  var KIT_HIGHLIGHT_CLASS = 'is-anchor-highlighted';
  var CATEGORY_ACTIVE_CLASS = 'is-active';
  var CATEGORY_FAQ_INDEX = {
    'studio-essentials': 2,
    'newborn-baby': 3,
    'maternity-family': 1,
    'headshots-portraits': 0
  };

  function resizeReviewsCarousel(reviewSection) {
    if (!reviewSection) return;

    var carousel = reviewSection.querySelector('.custom-review');
    if (!carousel) return;

    var resize = function () {
      var instance = null;

      if (window.Flickity && typeof window.Flickity.data === 'function') {
        instance = window.Flickity.data(carousel);
      }

      if (!instance && window.flkty && window.flkty.element === carousel) {
        instance = window.flkty;
      }

      if (instance && typeof instance.resize === 'function') {
        instance.resize();
      }
    };

    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(resize);
    } else {
      setTimeout(resize, 0);
    }
  }

  function findReviewsSection() {
    var marker = document.querySelector(REVIEWS_MARKER_SELECTOR);
    var section = marker ? marker.closest('.shopify-section') : null;

    if (section) return section;

    return document.querySelector(
      '.shopify-section[id*="' + REVIEWS_SECTION_ID_FRAGMENT + '"]'
    );
  }

  function moveReviewsSectionToSlot() {
    var slot = document.querySelector(REVIEWS_SLOT_SELECTOR);
    var reviewSection = findReviewsSection();

    if (!slot || !reviewSection) return;

    if (!slot.contains(reviewSection)) {
      slot.appendChild(reviewSection);
    }

    resizeReviewsCarousel(reviewSection);
  }

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function getHashFromHref(href) {
    if (!href || href.charAt(0) !== '#') return '';

    return href.slice(1);
  }

  function setActiveCategoryLink(root, hash) {
    [].forEach.call(root.querySelectorAll(CATEGORY_LINK_SELECTOR), function (link) {
      link.classList.toggle(CATEGORY_ACTIVE_CLASS, getHashFromHref(link.getAttribute('href')) === hash);
    });
  }

  function highlightKit(target) {
    if (!target) return;

    if (target._orientation2026HighlightTimer) {
      window.clearTimeout(target._orientation2026HighlightTimer);
    }

    target.classList.remove(KIT_HIGHLIGHT_CLASS);
    void target.offsetWidth;
    target.classList.add(KIT_HIGHLIGHT_CLASS);

    target._orientation2026HighlightTimer = window.setTimeout(function () {
      target.classList.remove(KIT_HIGHLIGHT_CLASS);
      target._orientation2026HighlightTimer = null;
    }, 4000);
  }

  function openContextFaq(hash) {
    var index = CATEGORY_FAQ_INDEX[hash];

    if (typeof index !== 'number') return;

    window.dispatchEvent(
      new CustomEvent('orientation-2026-open-faq', {
        detail: {
          category: hash,
          index: index
        }
      })
    );
  }

  function scrollToCategoryTarget(root, hash, pushHash) {
    var target = document.getElementById(hash);
    var behavior =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ? 'auto'
        : 'smooth';

    if (!target || !root.contains(target)) return false;

    if (pushHash && window.history && window.history.pushState) {
      window.history.pushState(null, '', '#' + hash);
    }

    setActiveCategoryLink(root, hash);
    openContextFaq(hash);
    highlightKit(target);
    target.scrollIntoView({ behavior: behavior, block: 'start' });

    window.setTimeout(function () {
      highlightKit(target);
    }, behavior === 'smooth' ? 700 : 0);

    return true;
  }

  function scrollToAnchorTarget(root, hash, pushHash) {
    var target = document.getElementById(hash);
    var behavior =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ? 'auto'
        : 'smooth';

    if (!target || !root.contains(target)) return false;

    if (pushHash && window.history && window.history.pushState) {
      window.history.pushState(null, '', '#' + hash);
    }

    target.scrollIntoView({ behavior: behavior, block: 'start' });

    return true;
  }

  function setupCategoryNavigation() {
    var roots = document.querySelectorAll('.orientation-2026-section');

    [].forEach.call(roots, function (root) {
      if (root.dataset.categoryNavBound === 'true') return;
      root.dataset.categoryNavBound = 'true';

      [].forEach.call(root.querySelectorAll(CATEGORY_LINK_SELECTOR), function (link) {
        link.addEventListener('click', function (event) {
          var hash = getHashFromHref(link.getAttribute('href'));

          if (!hash) return;

          event.preventDefault();
          scrollToCategoryTarget(root, hash, true);
        });
      });

      [].forEach.call(root.querySelectorAll(ANCHOR_LINK_SELECTOR), function (link) {
        link.addEventListener('click', function (event) {
          var hash = getHashFromHref(link.getAttribute('href'));

          if (!hash) return;

          if (scrollToAnchorTarget(root, hash, true)) {
            event.preventDefault();
          }
        });
      });

      if (window.location.hash) {
        var initialHash = window.location.hash.slice(1);
        var initialTarget = document.getElementById(initialHash);

        if (initialTarget && root.contains(initialTarget)) {
          setActiveCategoryLink(root, initialHash);
          openContextFaq(initialHash);
          window.setTimeout(function () {
            highlightKit(initialTarget);
          }, 500);
        }
      }
    });
  }

  onReady(moveReviewsSectionToSlot);
  onReady(setupCategoryNavigation);
  document.addEventListener('shopify:section:load', moveReviewsSectionToSlot);
  document.addEventListener('shopify:section:load', setupCategoryNavigation);

  document.addEventListener('alpine:init', function () {
    Alpine.data('orientation2026Root', function () {
      return {
        openModalId: '',
        kitCurrentStep: 1,
        kitTotalSteps: 3,
        cartItemCount: 0,
        activeBannerIndex: 0,
        bannerSlideCount: 1,
        bannerInterval: null,
        bannerAutoplay: true,
        bannerIntervalMs: 5000,
        bannerPauseOnHover: true,
        bannerReducedMotion: false,

        init: function () {
          var self = this;
          this.cartItemCount = parseInt(this.$el.getAttribute('data-cart-item-count'), 10) || 0;
          var banner = this.$el.querySelector('[data-banner-slide-count]');
          this.bannerSlideCount = banner ? parseInt(banner.getAttribute('data-banner-slide-count'), 10) || 1 : 1;
          this.bannerAutoplay = banner ? banner.getAttribute('data-banner-autoplay') === 'true' : true;
          this.bannerIntervalMs = banner ? parseInt(banner.getAttribute('data-banner-interval'), 10) || 5000 : 5000;
          this.bannerPauseOnHover = banner ? banner.getAttribute('data-banner-pause-on-hover') === 'true' : true;
          this.bannerReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          [].forEach.call(this.$el.querySelectorAll('.orientation-2026-banner-carousel .is-initial'), function (el) {
            el.classList.remove('is-initial');
          });
          this.startBannerCarousel();
          this.$watch('openModalId', function (id) {
            if (id) {
              var modal = self.$el.querySelector('[data-kit-modal-id="' + id + '"]');
              var total = modal ? parseInt(modal.getAttribute('data-kit-total-steps'), 10) : 3;
              self.kitTotalSteps = total;
              self.kitCurrentStep = 1;
              document.body.style.overflow = 'hidden';
              self.$nextTick(function () {
                self.bindKitFormHandlers(id);
                self.resizeFlickityInModal(id);
              });
            } else {
              document.body.style.overflow = '';
            }
          });

          this.$watch('kitCurrentStep', function () {
            var id = self.openModalId;
            if (id) {
              self.$nextTick(function () {
                self.resizeFlickityInModal(id);
              });
            }
          });
        },

        openKitModal: function (modalId) {
          this.openModalId = modalId;
        },

        startBannerCarousel: function () {
          var self = this;
          if (this.bannerInterval) {
            clearInterval(this.bannerInterval);
            this.bannerInterval = null;
          }
          if (this.bannerSlideCount <= 1 || !this.bannerAutoplay || this.bannerReducedMotion) return;
          this.bannerInterval = setInterval(function () {
            self.activeBannerIndex = (self.activeBannerIndex + 1) % self.bannerSlideCount;
          }, this.bannerIntervalMs);
        },

        pauseBannerCarousel: function () {
          if (this.bannerInterval) {
            clearInterval(this.bannerInterval);
            this.bannerInterval = null;
          }
        },

        pauseBannerOnHover: function () {
          if (this.bannerPauseOnHover) {
            this.pauseBannerCarousel();
          }
        },

        resumeBannerOnHover: function () {
          if (this.bannerPauseOnHover) {
            this.startBannerCarousel();
          }
        },

        setBannerSlide: function (index) {
          if (index < 0 || index >= this.bannerSlideCount) return;
          this.activeBannerIndex = index;
          this.startBannerCarousel();
        },

        closeKitModal: function () {
          this.openModalId = '';
        },

        advanceKitStep: function () {
          if (this.kitCurrentStep <= this.kitTotalSteps) {
            this.kitCurrentStep += 1;
          }
        },

        bindKitFormHandlers: function (modalId) {
          var self = this;
          var modal = this.$el.querySelector('[data-kit-modal-id="' + modalId + '"]');
          if (!modal) return;

          var forms = modal.querySelectorAll('form[is="product-form"]');
          [].forEach.call(forms, function (form) {
            if (form.dataset.kitBound) return;
            form.dataset.kitBound = '1';

            form.addEventListener('variant:added', function () {
              self.advanceKitStep();
              self.refreshCartItemCount();
            });

            form.addEventListener('cart-notification:show', function (e) {
              if (e.detail && e.detail.status === 'error') {
                alert(e.detail.error || 'Failed to add to cart');
                e.preventDefault();
              } else {
                e.preventDefault();
              }
            });
          });

          [].forEach.call(modal.querySelectorAll('[data-skip-step]'), function (btn) {
            if (btn.dataset.skipBound) return;
            btn.dataset.skipBound = '1';
            btn.addEventListener('click', function () {
              self.advanceKitStep();
            });
          });

        },

        resizeFlickityInModal: function (modalId) {
          var modal = this.$el.querySelector('[data-kit-modal-id="' + modalId + '"]');
          if (!modal) return;

          setTimeout(function () {
            var carousels = modal.querySelectorAll('flickity-carousel');
            [].forEach.call(carousels, function (carousel) {
              if (carousel.flickityInstance) {
                carousel.flickityInstance.then(function (flkty) {
                  flkty.resize();
                });
              }
            });
          }, 150);
        },

        refreshCartItemCount: function () {
          var self = this;
          var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          fetch(root + 'cart.js', { credentials: 'same-origin' })
            .then(function (res) {
              if (!res.ok) throw new Error('Failed to load cart');
              return res.json();
            })
            .then(function (cart) {
              self.cartItemCount = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
            })
            .catch(function () {
              // Keep current UI state when cart fetch fails.
            });
        }
      };
    });
  });
})();
